import {Directive, ElementRef, AfterViewInit, Input, Output, EventEmitter} from '@angular/core';

declare var $: any;

@Directive({
    selector: '[appDateRangePicker]'
})
export class DateRangePickerDirective implements AfterViewInit {

    @Input() value: any;
    @Output() onChange = new EventEmitter<string[]>();
    private _element: any;

    constructor(el: ElementRef) {
        this._element = $(el.nativeElement);
    }

    ngAfterViewInit() {
        this._element.daterangepicker({
            applyClass: 'bg-slate-600',
            cancelClass: 'btn-light',
            timePicker: true,
            locale: {
                format: 'MM/DD/YYYY hh:mm A'
            }
        });
        this._element.val(this.value).trigger('change');
        this._element.on('change', (e: any) => {
            this.onChange.emit($(e.target).val());
        });
    }

}
